import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Tooltip = ({ position }: { position: 'bottom' | 'top' }) => {
  return <div className={cx('toolTip', position)}>잊어버린 경력 쉽게 불러오기</div>;
};

export default Tooltip;
